export default 'https://ethereum-rpc.publicnode.com'